import React from 'react';
import {
    AdFlag,
    AeFlag,
    AfFlag,
    AlFlag,
    AmFlag,
    AtFlag,
    AxFlag,
    AzFlag,
    BaFlag,
    BeFlag,
    BgFlag,
    BhFlag,
    ChFlag,
    CyFlag,
    CzFlag,
    DeFlag,
    DkFlag,
    DzFlag,
    EeFlag,
    EgFlag,
    EsFlag,
    FiFlag,
    FoFlag,
    FrFlag,
    GbFlag,
    GeFlag,
    GgFlag,
    GiFlag,
    GlFlag,
    GrFlag,
    HrFlag,
    HuFlag,
    IeFlag,
    IlFlag,
    ImFlag,
    IoFlag,
    IsFlag,
    ItFlag,
    JeFlag,
    JoFlag,
    KgFlag,
    KwFlag,
    KzFlag,
    LiFlag,
    LsFlag,
    LtFlag,
    LuFlag,
    LvFlag,
    LyFlag,
    MaFlag,
    McFlag,
    MdFlag,
    MeFlag,
    MkFlag,
    MnFlag,
    MrFlag,
    MtFlag,
    MzFlag,
    NlFlag,
    NoFlag,
    OmFlag,
    PkFlag,
    PlFlag,
    PtFlag,
    QaFlag,
    RoFlag,
    RsFlag,
    SaFlag,
    SeFlag,
    SiFlag,
    SkFlag,
    SmFlag,
    SzFlag,
    TjFlag,
    TmFlag,
    TnFlag,
    TrFlag,
    UaFlag,
    UsFlag,
    UzFlag,
    VaFlag,
    XkFlag,
    YeFlag,
    ZaFlag,
    ZwFlag,
} from '@fiverr-private/visuals';

export const countries = new Map([
    ['AD', <AdFlag key="AD" />],
    ['AE', <AeFlag key="AE" />],
    ['AF', <AfFlag key="AF" />],
    ['AL', <AlFlag key="AL" />],
    ['AM', <AmFlag key="AM" />],
    ['AT', <AtFlag key="AT" />],
    ['AX', <AxFlag key="AX" />],
    ['AZ', <AzFlag key="AZ" />],
    ['BA', <BaFlag key="BA" />],
    ['BE', <BeFlag key="BE" />],
    ['BG', <BgFlag key="BG" />],
    ['BH', <BhFlag key="BH" />],
    ['CH', <ChFlag key="CH" />],
    ['CY', <CyFlag key="CY" />],
    ['CZ', <CzFlag key="CZ" />],
    ['DE', <DeFlag key="DE" />],
    ['DK', <DkFlag key="DK" />],
    ['DZ', <DzFlag key="DZ" />],
    ['EE', <EeFlag key="EE" />],
    ['EG', <EgFlag key="EG" />],
    ['ES', <EsFlag key="ES" />],
    ['FI', <FiFlag key="FI" />],
    ['FO', <FoFlag key="FO" />],
    ['FR', <FrFlag key="FR" />],
    ['GB', <GbFlag key="GB" />],
    ['GE', <GeFlag key="GE" />],
    ['GG', <GgFlag key="GG" />],
    ['GI', <GiFlag key="GI" />],
    ['GL', <GlFlag key="GL" />],
    ['GR', <GrFlag key="GR" />],
    ['HR', <HrFlag key="HR" />],
    ['HU', <HuFlag key="HU" />],
    ['IE', <IeFlag key="IE" />],
    ['IL', <IlFlag key="IL" />],
    ['IM', <ImFlag key="IM" />],
    ['IO', <IoFlag key="IO" />],
    ['IS', <IsFlag key="IS" />],
    ['IT', <ItFlag key="IT" />],
    ['JE', <JeFlag key="JE" />],
    ['JO', <JoFlag key="JO" />],
    ['KG', <KgFlag key="KG" />],
    ['KW', <KwFlag key="KW" />],
    ['KZ', <KzFlag key="KZ" />],
    ['LI', <LiFlag key="LI" />],
    ['LS', <LsFlag key="LS" />],
    ['LT', <LtFlag key="LT" />],
    ['LU', <LuFlag key="LU" />],
    ['LV', <LvFlag key="LV" />],
    ['LY', <LyFlag key="LY" />],
    ['MA', <MaFlag key="MA" />],
    ['MC', <McFlag key="MC" />],
    ['MD', <MdFlag key="MD" />],
    ['ME', <MeFlag key="ME" />],
    ['MK', <MkFlag key="MK" />],
    ['MN', <MnFlag key="MN" />],
    ['MR', <MrFlag key="MR" />],
    ['MT', <MtFlag key="MT" />],
    ['MZ', <MzFlag key="MZ" />],
    ['NL', <NlFlag key="NL" />],
    ['NO', <NoFlag key="NO" />],
    ['OM', <OmFlag key="OM" />],
    ['PK', <PkFlag key="PK" />],
    ['PL', <PlFlag key="PL" />],
    ['PT', <PtFlag key="PT" />],
    ['QA', <QaFlag key="QA" />],
    ['RO', <RoFlag key="RO" />],
    ['RS', <RsFlag key="RS" />],
    ['SA', <SaFlag key="SA" />],
    ['SE', <SeFlag key="SE" />],
    ['SI', <SiFlag key="SI" />],
    ['SK', <SkFlag key="SK" />],
    ['SM', <SmFlag key="SM" />],
    ['SZ', <SzFlag key="SZ" />],
    ['TJ', <TjFlag key="TJ" />],
    ['TM', <TmFlag key="TM" />],
    ['TN', <TnFlag key="TN" />],
    ['TR', <TrFlag key="TR" />],
    ['UA', <UaFlag key="UA" />],
    ['US', <UsFlag key="US" />],
    ['UZ', <UzFlag key="UZ" />],
    ['VA', <VaFlag key="VA" />],
    ['XK', <XkFlag key="XK" />],
    ['YE', <YeFlag key="YE" />],
    ['ZA', <ZaFlag key="ZA" />],
    ['ZW', <ZwFlag key="ZW" />],
]);
